import { render, staticRenderFns } from "./filterRule.vue?vue&type=template&id=56a8edc8&scoped=true"
import script from "./filterRule.vue?vue&type=script&lang=js"
export * from "./filterRule.vue?vue&type=script&lang=js"
import style0 from "./filterRule.vue?vue&type=style&index=0&id=56a8edc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56a8edc8",
  null
  
)

export default component.exports